import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		loggedIn: false,
		user: null,
		loaderCount: 0,
		breadcrumbs: [],
		subMenuLists: false,
		subMenuFinance: false,
		subMenuReporting: false,
		subMenuSettings: false
	},
	mutations: {
		setLoggedIn(state, value) {
			state.loggedIn = value;
		},
		setUser(state, value) {
			state.user = value;
		},
		increaseLoaderCount(state) {
			setTimeout(() => {
				state.loaderCount++;
			}, 200);
		},
		decreaseLoaderCount(state) {
			state.loaderCount--;
		},
		setBreadcrumbs(state, value) {
			state.breadcrumbs = value;
		},
		setSubMenuLists(state, value) {
			state.subMenuLists = value;
		},
		setSubMenuFinance(state, value) {
			state.subMenuFinance = value;
		},
		setSubMenuReporting(state, value) {
			state.subMenuReporting = value;
		},
		setSubMenuSettings(state, value) {
			state.subMenuSettings = value;
		}
	}
})
